import * as yup from 'yup'
import constants from 'constants/index'

const allowedTypes = constants.consent.SUPPORTED_DOCUMENT_FILE_INPUT_TYPES

const schema = yup.object({
  document: yup.mixed().fileUpload({
    types: allowedTypes,
    mimeTypes: constants.consent.SUPPORTED_DOCUMENT_FILE_SCHEMA_TYPES,
    required: true,
  }),
})

export default schema
